<template>
  <AppHeader/>
  <router-view></router-view>
</template>

<script>
import AppHeader from '@/components/AppHeader'
export default {
  name: "Albums",
  components: { AppHeader }
}
</script>

<style scoped>

</style>
